export default __webpack_public_path__ + "static/media/netto-logo.17307717.svg";